import forge from 'node-forge';

export function encryptPassword(plainText: string, publicKey: string) {
  const pem = `-----BEGIN PUBLIC KEY-----\n${publicKey}\n-----END PUBLIC KEY-----`;
  const rsaKey = forge.pki.publicKeyFromPem(pem);
  return forge.util.encode64(rsaKey.encrypt(plainText));
}

export function getOsInfo() {
  const userAgent = window.navigator.userAgent;
  if (userAgent.includes('Windows Phone')) return 'Windows Phone';
  if (userAgent.includes('Windows NT')) return 'Windows';
  if (userAgent.includes('Mac')) return 'Mac';
  if (userAgent.includes('X11')) return 'UNIX';
  if (userAgent.includes('Linux')) return 'Linux';
  if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod')) return 'iOS';
  if (userAgent.includes('Android')) return 'Android';
  if (userAgent.includes('BlackBerry')) return 'BlackBerry';
  if (userAgent.includes('webOS')) return 'webOS';
  return 'unknown';
}

export function getBrowserInfo() {
  const ua = window.navigator.userAgent.toLowerCase();
  const browserPatterns: Record<string, RegExp> = {
    ie: /rv:([\d.]+)\) like gecko/,
    edge: /edge\/([\d.]+)/,
    firefox: /firefox\/([\d.]+)/,
    opera: /(?:opera|opr).([\d.]+)/,
    chrome: /chrome\/([\d.]+)/,
    safari: /version\/([\d.]+).*safari/
  };

  for (const [browserName, pattern] of Object.entries(browserPatterns)) {
    const match = pattern.exec(ua);
    if (match) {
      const capitalizedName = browserName === 'ie' ? 'IE' : browserName.charAt(0).toUpperCase() + browserName.slice(1);
      return { name: capitalizedName, version: match[1] };
    }
  }

  return { name: 'Unknown', version: '0.0.0' };
}

export function encrypt(password, publicKey) {
  publicKey = `-----BEGIN PUBLIC KEY-----\n` + publicKey + `\n-----END PUBLIC KEY-----`
  publicKey = forge.pki.publicKeyFromPem(publicKey)
  return forge.util.encode64(publicKey.encrypt(password))
}
